import { injectReducer } from '../../store/reducers'
import { getPatientDetail, getPatientHistory, clearState } from './modules/patientDetail'

export default (store) => ({
  path : '/patient/:id',
  childRoutes: [
  ],
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const PatientDetail = require('./containers/PatientDetailContainer').default
      const reducer = require('./modules/patientDetail').default
      injectReducer(store, { key: 'patientDetail', reducer })
      var patientId = nextState.params.id
      store.dispatch(clearState())
      store.dispatch(getPatientDetail(patientId));
      cb(null, PatientDetail)
    }, 'patientDetail')
  }
})


// WEBPACK FOOTER //
// ./src/routes/PatientDetail/index.js